class CommonURL {
  getURL(url, params = {}, headers = {}) {
    let localUrl = url;

    if (params.domainUrl || params['domain-url']) {
      localUrl = `${params.domainUrl || params['domain-url']}${localUrl.startsWith('/') ? localUrl : `/${localUrl}`}`;
      delete params.domainUrl;
      delete params['domain-url'];
    } else if (!localUrl.startsWith('http')) {
      localUrl = `${process.env.REACT_APP_API_SERVER}${localUrl.startsWith('/') ? localUrl : `/${localUrl}`}`;
    }

    const myHeaders = new Headers();
    Object.entries(headers).forEach(([key, value]) =>
      myHeaders.append(key, value),
    );

    return { urlProcess: localUrl, allParams: params, headersData: myHeaders };
  }

  createFrom(params, form = new FormData()) {
    if (!params) return form;

    Object.entries(params).forEach(([key, value]) =>
      this.simplifyParams(form, key, value),
    );
    return form;
  }

  simplifyParams(form, key, param) {
    if (param === undefined) return;

    if (typeof param !== 'object' || param instanceof File || param === null) {
      form.append(key, param);
    } else if (Array.isArray(param)) {
      param.forEach((value, i) =>
        this.simplifyParams(form, `${key}[${i}]`, value),
      );
    } else {
      Object.entries(param).forEach(([subKey, value]) =>
        this.simplifyParams(form, `${key}[${subKey}]`, value),
      );
    }
  }
}

export default new CommonURL();
